import { createContext } from "react";
import IRefContext from './IRefContext'

const defaultRefContext: IRefContext = {}

export const RefContext = createContext(defaultRefContext)
const RefContextProvider = RefContext.Provider

export default RefContextProvider